import { makeEmployeeDashboardApiRequest } from "../../api_helper";

// Send otp to Initiate Complete KYC Reg Form 
export const retrieve_specific_country_all_user_kyc_det_api = (formData) =>
  makeEmployeeDashboardApiRequest("post", "locations/retrieve_specific_country_all_user_kyc_det", formData);
